module.exports = __webpack_public_path__ + "static/italian-6281eb4d4e2d81a1b9503b3dcd634be0.jpg";